import styled from 'styled-components'
import { Select as AntSelect } from 'antd'
import {
  FONT_WEIGHT,
  BORDER_RADIUS,
  FONT_SIZE,
  PADDING,
} from 'parkway-web-common'
import { Dimension } from 'parkway-web-common'
import { normalizeProp } from 'app/hook'
import { SearchOutlined } from '@ant-design/icons'

export interface InternalSelectProps {
  $width?: Dimension
  $shadow?: boolean
}

export const DropdownRender = styled.div`
  & .ant-select-item:hover {
    background-color: var(--other-blue-color);
    color: var(--text-sider-secondary-color);
  }
`

export const SearchWrapper = styled.div`
  position: relative;
  padding: ${PADDING.xxxxs};
  border-bottom: 1px solid var(--neutral-black-9-color);
  margin-bottom: ${PADDING.xxxxs};

  & .search {
    &__input {
      padding: ${PADDING.xxxxs};
      padding-left: ${PADDING.xxxxl};
    }
  }
`

export const SearchOutlinedStyled = styled(SearchOutlined)`
  padding-left: ${PADDING.xxxxs};
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  left: ${PADDING.xxxxs};
  color: '#002244';
  font-size: ${PADDING.xl};
`

export const Select = styled(AntSelect)<InternalSelectProps>`
  width: ${props => props.$width && normalizeProp(props.$width)};

  font-weight: ${FONT_WEIGHT.medium};

  box-shadow: ${props => props.$shadow && 'var(--box-shadow)'};

  &.ant-select-borderless {
    background: var(--secondary-background-color);

    border-radius: ${BORDER_RADIUS};
  }

  .ant-select-selection-placeholder {
    font-size: ${FONT_SIZE.xs};

    color: var(--text-main-color);
  }

  .ant-select-arrow {
    color: var(--text-main-color);
    top: calc(50% - 4px);
    right: 8px;
  }

  &.ant-select-multiple.ant-select-sm .ant-select-selection-item {
    height: 0.875rem;
    line-height: ${FONT_SIZE.xs};
    font-size: ${FONT_SIZE.xs};
    margin-top: 0.1875rem;
    margin-bottom: 0.1875rem;
  }

  &.ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    color: var(--disabled-color);
  }

  .ant-select-clear {
    color: var(--disabled-color);
  }
  .ant-select-selection-item-remove {
    color: var(--icon-color);
    &:hover {
      color: var(--icon-hover-color);
    }
  }
  .ant-select-item-option-disabled {
    color: var(--disabled-color);
  }

  min-width: 200px !important;

  .ant-select-dropdown
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: var(--background-color) !important;
    transition: all 0.5s ease;

    .ant-select-item-option-content {
      color: var(--primary-color) !important;
      transition: all 0.5s ease;
    }
  }
  .ant-select-dropdown .ant-select-item-option {
    margin-bottom: ${PADDING.xxxxs};
  }
`
export const Placeholder = styled.div`
  color: var(--main-2-color);
  font-weight: ${FONT_WEIGHT.regular};
  font-size: ${FONT_SIZE.xs};
`
